/* eslint-disable @angular-eslint/component-class-suffix */
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthFacade } from '../../+state/auth.facade';

/**
 * Login component
 */
@Component({
  templateUrl: './forbidden.container.html',
  styleUrls: ['./forbidden.container.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ForbiddenContainer {
  constructor(private facade: AuthFacade) {}

  error$ = this.facade.error$;

  logout() {
    this.facade.logout();
  }
}
